export default {
  meta: {
    title: '部门管理',
    url: '/organization/department', // 埋点用，记录所属模块
    // eventId: 'bf49159e-f391-457c-baa7-8dcc60e810af'
  }
};
